import { createFileRoute } from "@tanstack/react-router";
import WorkspaceGroupsPage from "@/components/settings/workspace/workspace-groups-page";

export const Route = createFileRoute("/_app/settings/workspace/team/groups/")({
	component: WorkspaceGroupsPage,
});
